import React, { FC, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { Session } from "@models/session";
import { ActivityType } from "@models/activity-type";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { DateUtil } from "@utils/date.util";
import InsertPhotoOutlinedIcon from "@mui/icons-material/InsertPhotoOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import { Link } from "react-router-dom";

const Container = styled.div`
  border-radius: 12px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.08);
  border-style: solid;
  padding: 12px 20px;
  overflow: hidden;
`;

const SummaryText = styled.span`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  display: -webkit-box;
  overflow: hidden;
  font-size: 15px;
  line-height: 1.55;
`;

const ConversationItem: FC<{
  session: Session;
}> = ({ session }) => {
  const { t } = useTranslation();

  const title = useMemo(() => {
    return t(`sessions.types.${session.activityType}`);
  }, [session, t]);

  const sessionDate = useMemo(
    () => DateUtil.formatTime(session.createdDate),
    [session],
  );

  return (
    <Container>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        gap="8px"
      >
        <Typography
          color="textSecondary"
          fontSize="20px"
          fontWeight="500"
          lineHeight="30px"
          marginBottom="6px"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          sx={{ textDecoration: "none" }}
          component={Link}
          to={`transcripts/${session.id}`}
        >
          {title}
        </Typography>

        <Box sx={{ svg: { color: "primary.main" } }}>
          {session.activityType === ActivityType.GallerySession ? (
            <InsertPhotoOutlinedIcon />
          ) : (
            <SmsOutlinedIcon />
          )}
        </Box>
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
        fontSize="14px"
        lineHeight="22px"
        fontWeight="400"
        color="#171A1FFF"
        gap="8px"
      >
        <SummaryText>{session.summary}</SummaryText>
        <span style={{ whiteSpace: "nowrap" }}>{sessionDate}</span>
      </Box>
    </Container>
  );
};

export default ConversationItem;
